<template>
  <div class="sign-entry-preview-page">
    <section class="preview-header">
      <div class="preview-title">
        <span class="preview-kicker">签约管理</span>
        <h1>签约录入</h1>
        <p>录入红人身份、签约信息和签约前平台资料</p>
      </div>
      <div class="preview-status-card">
        <span>录入状态</span>
        <strong>{{ dataForm.id ? '编辑签约' : '新建签约' }}</strong>
      </div>
    </section>

    <el-form
      ref="refForm"
      class="preview-form"
      :model="dataForm"
      :rules="rules"
      label-position="top"
      size="small">
      <div class="preview-layout">
        <main class="preview-main">
          <section class="preview-panel">
            <div class="panel-header">
              <div>
                <h2>身份资料</h2>
                <p>录入红人基础身份和联系方式</p>
              </div>
            </div>
            <el-row :gutter="16" class="panel-body">
              <el-col :span="12">
                <el-form-item label="红人昵称" prop="nickname">
                  <el-input
                    v-model="dataForm.nickname"
                    placeholder="输入红人昵称"
                    maxlength="100"
                    clearable
                    @blur="checkNickname"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="红人姓名" prop="real_name">
                  <el-input
                    v-model="dataForm.real_name"
                    placeholder="输入红人真实姓名"
                    maxlength="50"
                    clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="身份证号" prop="id_card">
                  <el-input
                    v-model="dataForm.id_card"
                    placeholder="输入红人身份证号"
                    maxlength="18"
                    clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号" prop="tel">
                  <el-input
                    v-model="dataForm.tel"
                    placeholder="输入红人手机号"
                    maxlength="20"
                    clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="微信号">
                  <el-input
                    v-model="dataForm.wechat"
                    placeholder="输入红人微信号"
                    maxlength="50"
                    clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="常用地址" prop="address">
                  <el-input
                    v-model="dataForm.address"
                    placeholder="输入联系地址"
                    maxlength="255"
                    clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </section>

          <section class="preview-panel">
            <div class="panel-header">
              <div>
                <h2>签约信息</h2>
                <p>填写签约归属、合同和结算条件</p>
              </div>
            </div>
            <el-row :gutter="16" class="panel-body sign-info-body">
              <el-col :span="8">
                <el-form-item label="签约人" required>
                  <SignatoryQuery
                    v-model="dataForm.signatory"
                    :name="dataForm.signatory"
                    :showSet="true"
                    @handleSelect="handleSelect"
                    @changeValue="changeSignatory"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="账号来源">
                  <AccountSourceSelect v-model="dataForm.account_source" placeholder="选择账号来源"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="签约类型" prop="sign_type">
                  <el-select v-model="dataForm.sign_type" placeholder="选择签约类型" clearable>
                    <el-option
                      v-for="(item, value) in MapSignType"
                      :key="value"
                      :label="item.label"
                      :value="value"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="签约日期" prop="sign_date">
                  <el-date-picker
                    v-model="dataForm.sign_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择签约日期"
                    clearable
                    @change="changeSignDate"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="签约年份">
                  <el-input v-model="dataForm.year" placeholder="签约年份" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="签约月份">
                  <el-input v-model="dataForm.month" placeholder="签约月份" disabled/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="签约后主平台" prop="platform_code_aft">
                  <el-select v-model="dataForm.platform_code_aft" placeholder="选择签约主平台" clearable>
                    <el-option
                      v-for="item in platformOptions"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="合约性质" prop="nature">
                  <el-select v-model="dataForm.nature" placeholder="选择合约类型" clearable>
                    <el-option label="全约" :value="1"/>
                    <el-option label="商务约" :value="2"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="合约年限" prop="term">
                  <el-input
                    v-model="dataForm.term"
                    placeholder="输入合约年限"
                    clearable
                    oninput="value=value.replace(/[^\d^\.^\-]/g,'')"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="续约年限">
                  <el-input
                    v-model="dataForm.renewal_years"
                    placeholder="输入续约年限"
                    clearable
                    oninput="value=value.replace(/[^\d^\.^\-]/g,'')"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="续约条件（万）" prop="renewal_cond">
                  <el-input
                    v-model="dataForm.renewal_cond"
                    placeholder="输入续约条件（万）"
                    clearable
                    oninput="value=value.replace(/[^\d^\.^\-]/g,'')"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="博主分成比例">
                  <el-input
                    v-model="dataForm.blogger_ratio"
                    placeholder="输入博主分成比例"
                    clearable
                    oninput="value=value.replace(/[^\d^\.^\-]/g,'')">
                    <template slot="append">%</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="合同编号">
                  <el-input
                    v-model="dataForm.contract_no"
                    placeholder="输入合同编号"
                    maxlength="100"
                    clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-if="!dataForm.id">
                <el-form-item label="分配组别" prop="group_id">
                  <EcpDeptSelect ref="refDeptCascader" @handleSelect="selectDept"/>
                </el-form-item>
              </el-col>
              <el-col :span="8" v-else>
                <div class="preview-form-tip">
                  <i class="el-icon-info"></i>
                  分配组别只能通过转组功能修改，编辑保存不生效
                </div>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input
                    v-model="dataForm.remark"
                    type="textarea"
                    placeholder="输入备注"
                    maxlength="255"
                    :rows="4"
                    clearable/>
                </el-form-item>
              </el-col>
            </el-row>
          </section>
        </main>

        <aside class="preview-side">
          <section class="preview-panel preview-platform-panel">
            <div class="panel-header">
              <div>
                <h2>签约前平台</h2>
                <p>补充签约前账号信息</p>
              </div>
            </div>
            <div class="platform-body">
              <BefPlatformInfo
                compact
                :data="dataForm.sign_bef_info || []"
                :edit="true"
                @currentInfo="getBefPlatformInfo"/>
            </div>
          </section>
        </aside>
      </div>
    </el-form>

    <div class="preview-actions">
      <el-button
        v-if="userPermissions.indexOf('sign_enter_page') > -1"
        type="primary"
        icon="el-icon-check"
        class="preview-save-btn"
        @click="saveConfirm">
        保存
      </el-button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import BefPlatformInfo from '@/pages/sign_info/components/BefPlatformInfo'
import SignatoryQuery from '@/pages/sign_info/components/SignatoryQuery'
import EcpDeptSelect from '@/pages/commerce/kol_mapper/EcpDeptSelect'
import AccountSourceSelect from '@/pages/sign_info/components/AccountSourceSelect.vue'
import {MapSignType} from '@/enum/sign-info'

export default {
  name: 'SignInfoCreateEditPreview',
  components: {
    AccountSourceSelect,
    BefPlatformInfo,
    SignatoryQuery,
    EcpDeptSelect
  },
  watch: {
    // eslint-disable-next-line
    '$route'(to, from) {
      this.initForm()
    }
  },
  data() {
    //验证红人id
    const validateSignid = (rule, value, callback) => {
      if (value === '' || this.dataForm.sign_artist_id == null) {
        callback(new Error(''))
      } else {
        if (this.dataForm.sign_artist_id !== '') {
          // console.log(this.dataForm.sign_artist_id)
          callback()
          // this.$refs.dataForm.validateField('sign_artist_id')
        }
        callback()
      }
    }

    return {
      MapSignType,
      id: null,
      dataForm: {
        type: 'first',
        year: null,
        month: null,
        sign_date: null,
        group_id: null,
        account_source: null,
        nickname: '',
        is_second_sign: '0',
        sign_artist_id: null,
        sign_type: null,
        real_name: '',
        id_card: '',
        tel: '',
        wechat: '',
        address: '',
        contract_no: '',
        sign_bef_info: []
      },
      accountSourceOptions: [
        { label: '组内提供微信', val: 'pwg' },
        { label: '自己寻找', val: 'fys' }
      ],
      monthOptions: [],
      signatoryOptions: [],
      platformOptions: [],
      rules: {
        nickname: [{ required: true, message: '输入红人昵称', trigger: 'blur' }],
        signatory: [{ required: true, message: '输入签约人', trigger: 'blur' }],
        sign_date: [{ required: true, message: '输入签约时间', trigger: 'blur' }],
        id_card: [{ required: true, message: '输入身份证号', trigger: 'blur' }],
        group_id: [{ required: true, message: '分组必选', trigger: 'blur' }],
        term: [{ required: true, message: '输入合约年限', trigger: 'blur' }],
        platform_code_aft: [{ required: true, message: '输入签约后主平台', trigger: 'blur' }],
        renewal_cond: [{ required: true, message: '续约条件必填', trigger: 'blur' }],
        is_second_sign: [{ required: true, message: '是否二次签约必选', trigger: 'blur' }],
        sign_artist_id: [{ validator: validateSignid, message: '首次签约id必选', trigger: 'blur' }],
        tel: [{ required: true, message: '输入联系方式', trigger: 'blur' }],
        address: [{ required: true, message: '输入常用地址', trigger: 'blur' }]
      },
      searchCondition: {
        group_id: null,
        artist_id: null,
        nickname: null,
        ym: null,
        platform_code: null,
        platform_name: ''
      }
    }
  },

  created() {
    this.initOptions()
  },
  mounted() {
    this.initForm()
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  methods: {
    //验证是否有红人id
    async initSignatoryOption() {
      const { list } = await this.$api.getSignInfoSignatoryList()
      this.signatoryOptions = []
      list.forEach((item) => {
        this.signatoryOptions.push({ value: item.userid, label: item.name })
      })
    },
    async checkNickname() {
      if (this.dataForm.is_second_sign == '1') {
        return false
      }
      const params = { id: this.dataForm.artist_id, nickname: this.dataForm.nickname }
      const { is_used, artist_id } = await this.$api.isUsedArtistNickname(params)
      if (is_used) {
        const title = '红人昵称：【' + params.nickname + '】已被占用'
        // this.$message.warning('红人昵称：【' + params.nickname + '】已被占用')
        this.$notify({
          title: title,
          dangerouslyUseHTMLString: true,
          message: '<a href="/artist/' + artist_id + '/edit">查看：' + params.nickname + '</a>',
          iconClass: 'el-icon-info',
          offset: 100,
          type: 'warning'
        })
      }
    },
    //初始化月份下拉框
    initOptions() {
      this.monthOptions = []
      for (let i = 1; i <= 12; i++) {
        this.monthOptions.push({ value: i, label: i + '月份' })
      }
      this.getPlatforms()
      this.initSignatoryOption()
    },
    async getPlatforms() {
      // 获取最新平台信息
      const { list } = await this.$api.getPlatforms()
      this.platformOptions = list
    },
    changeSignDate() {
      const sign_date = this.dataForm.sign_date
      if (sign_date && sign_date.indexOf('-') > -1) {
        const arr = sign_date.split('-')
        this.dataForm.year = arr[0]
        this.dataForm.month = parseInt(arr[1])
      } else {
        this.dataForm.year = null
        this.dataForm.month = null
      }

    },
    // 确认保存按钮
    async saveConfirm() {
      // 调用组件的数据验证方法
      this.$refs['refForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
      return true
    },
    // 相关信息的保存处理
    async formSubmit() {
      if (this.dataForm.is_second_sign) {
        this.dataForm.is_second_sign = this.dataForm.is_second_sign * 1
      }

      const { info: { id, artist_id } } = await this.$api.saveSignInfo(this.dataForm)
      if (id && artist_id) {
        this.$notify.success('保存成功！')
        this.detailPage(artist_id)
        // this.initForm()
      }
      // if (!this.artistId && id) {
      //   // this.$router.push(this.$route.matched[1].path+'/'+id+'/edit')
      //   this.$router.push(this.$route.matched[1].path)
      // }
    },
    // 选择分组
    selectGroup(val) {
      this.dataForm.group_id = val
    },
    selectDept(val) {

      let group_id = null
      if (val && val.length > 1) {
        group_id = val[val.length - 1]
      }
      this.dataForm.group_id = group_id ? group_id.dpt_id : null
    },
    buildDefaultForm() {
      return {
        type: 'first',
        year: null,
        month: null,
        sign_date: null,
        group_id: null,
        account_source: null,
        nickname: '',
        real_name: '',
        id_card: '',
        is_second_sign: '0',
        sign_artist_id: null,
        sign_type: null,
        platform_code_aft: null,
        nature: null,
        term: '',
        renewal_years: '',
        renewal_cond: '',
        blogger_ratio: '',
        tel: '',
        wechat: '',
        address: '',
        contract_no: '',
        remark: '',
        sign_bef_info: []
      }
    },
    initForm() {
      //
      this.id = this.$route.params.sign_id
      if (this.id) {
        this.getDetail()
      } else {
        this.dataForm = this.buildDefaultForm()
      }
    },
    async getDetail() {
      const { info } = await this.$api.getSignInfo(this.id)
      this.dataForm = {
        ...this.buildDefaultForm(),
        ...info,
        sign_bef_info: info.sign_bef_info || []
      }
    },

    //获取
    getBefPlatformInfo(val) {
      this.dataForm.sign_bef_info = [...val]
      // console.log(this.dataForm.sign_bef_info)
    },
    detailPage(id) {
      this.$router.push({ name: 'sign_detail', params: { id: id } })
    },
    //切换签约人
    handleSelect(item) {
      this.dataForm.signatory = item.value
    },
    async changeSignatory(val) {
      this.dataForm.signatory = val
    },
    async selectArtist(selectInfo) {
      if (!this.dataForm.artist_id) {
        this.dataForm.sign_artist_id = selectInfo.artist_id
        this.dataForm.nickname = selectInfo.nickname || ''
      }

    }
  },
  destroyed() {
    this.dataForm = this.buildDefaultForm()
  }

}
</script>

<style scoped>
.sign-entry-preview-page {
  height: 100%;
  max-height: calc(100vh - 116px);
  min-height: 0;
  padding: 14px 14px 86px;
  background: #f5f7fb;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;
}

.preview-header,
.preview-panel,
.preview-actions {
  background: #ffffff;
  border: 1px solid #e7ebf2;
  border-radius: 8px;
  box-sizing: border-box;
}

.preview-header {
  min-height: 104px;
  padding: 18px 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.preview-title {
  min-width: 0;
}

.preview-kicker {
  height: 24px;
  padding: 0 10px;
  color: #ff3176;
  background: #fff0f6;
  border: 1px solid #ffd1e2;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  line-height: 24px;
}

.preview-title h1 {
  margin: 8px 0 4px;
  color: #172033;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: 0;
}

.preview-title p {
  margin: 0;
  color: #7a8494;
  font-size: 13px;
  line-height: 20px;
}

.preview-status-card {
  min-width: 220px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 8px;
  box-sizing: border-box;
}

.preview-status-card span {
  color: #8a94a6;
  display: block;
  font-size: 12px;
  line-height: 18px;
}

.preview-status-card strong {
  margin-top: 4px;
  color: #263142;
  display: block;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.preview-form {
  margin-top: 12px;
}

.preview-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 420px;
  gap: 12px;
  align-items: start;
}

.preview-main,
.preview-side {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.preview-panel {
  min-width: 0;
  overflow: hidden;
}

.panel-header {
  min-height: 62px;
  padding: 13px 18px;
  border-bottom: 1px solid #edf1f6;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.panel-header h2 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
}

.panel-header p {
  margin: 2px 0 0;
  color: #8a94a6;
  font-size: 12px;
  line-height: 18px;
}

.panel-body {
  padding: 16px 18px 8px;
}

.sign-info-body {
  padding: 16px 18px 8px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 16px;
  row-gap: 0;
}

.sign-info-body::before,
.sign-info-body::after {
  display: none;
}

.sign-info-body > .el-col {
  width: auto !important;
  float: none;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.sign-info-body > .el-col-24 {
  grid-column: 1 / -1;
}

.preview-form ::v-deep .el-form-item {
  margin-bottom: 12px;
}

.preview-form ::v-deep .el-form-item__label {
  padding-bottom: 6px;
  color: #667085;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
}

.preview-form ::v-deep .el-input,
.preview-form ::v-deep .el-select,
.preview-form ::v-deep .el-date-editor,
.preview-form ::v-deep .el-autocomplete {
  width: 100%;
}

.preview-form ::v-deep .el-form-item__content > div {
  width: 100%;
}

.preview-form ::v-deep .el-textarea__inner {
  min-height: 74px !important;
}

.preview-form-tip {
  margin-top: 25px;
  padding: 0 12px;
  color: #667085;
  background: #f8fafc;
  border: 1px solid #edf1f6;
  border-radius: 6px;
  font-size: 12px;
  line-height: 32px;
}

.preview-form-tip i {
  margin-right: 4px;
  color: #2f7cf6;
}

.platform-body {
  padding: 14px 16px 16px;
}

.preview-platform-panel ::v-deep .el-table th {
  color: #475467;
  background: #f8fafc;
  font-weight: 600;
}

.preview-platform-panel ::v-deep .el-table td,
.preview-platform-panel ::v-deep .el-table th {
  border-color: #edf1f6;
}

.preview-actions {
  position: fixed;
  right: 24px;
  bottom: 18px;
  left: 24px;
  z-index: 10;
  min-height: 54px;
  padding: 9px 18px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.08);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.preview-save-btn {
  width: 128px;
}

@media (max-width: 1360px) {
  .preview-layout {
    grid-template-columns: 1fr;
  }

  .preview-side {
    display: grid;
    grid-template-columns: 340px minmax(0, 1fr);
    gap: 12px;
  }
}

</style>
